<div class="sticky-footer">
  <app-button buttonType="primary" size="md" label="{{'Get in Touch' | translate}}" (onClick)="contact()"></app-button>
  <app-button buttonType="primary" size="md" label="{{'Write Review' | translate}}" [outlined]="true" (onClick)="review()"></app-button>
</div>
